const RESPONSIVE_BREAKPOINT = 1106;

document.addEventListener("DOMContentLoaded", function() {
    updateImagePosition();
    window.addEventListener('resize', updateImagePosition);
});

function updateImagePosition() {
    var img = document.getElementById('responsive-hero-image');
    if (!img) return; // Exit if no image found

    var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    var desktopPosition = img.getAttribute('data-desktop-position');
    var mobilePosition = img.getAttribute('data-mobile-position');

    img.style.objectFit = "cover";
    img.style.objectPosition = (width <= RESPONSIVE_BREAKPOINT) ? mobilePosition : desktopPosition;
}